export default __webpack_public_path__ + "c0c5b70.png";